/* Packages */
import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import Slider from 'rc-slider';

/* Hooks */
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';

export default function ConversionFieldChoicesSlider(props) {
    const { field, path, id, updateValue = (value) => (value) } = props;
    const { label, choices, value } = field;
    const marks = Object.assign({}, choices?.map((choice) => (choice?.label)));

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const SliderHandle = (props) => {
        const { value, ...restProps } = props;

        return (
            <>
                <Slider.Handle value={value} {...restProps} />
            </>
        );
    };

    return (
        <div className="row gutters-0 mb-5">
            <div className="col-12">
                <div className="row gutters-2 align-items-center">
                    {label && (
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center">
                                <p className="flow__label mb-0">{label}</p>
                                <p className="text--14 font-weight-bold">{choices[choices?.findIndex((choice) => `${choice.key}` === `${value[0]}`)]?.label}</p>
                            </div>
                        </div>
                    )}
                </div>
                <Slider
                    id={`${id}.slider`}
                    className={``}
                    value={choices?.findIndex((choice) => `${choice.key}` === `${value[0]}`)}
                    marks={marks}
                    step={null}
                    min={0}
                    disabled={choices?.length > 1 ? false : true}
                    max={choices?.length - 1}
                    handle={SliderHandle}
                    onChange={(index) => {
                        updateValue([choices[index]?.key], () => {
                            trigger(path);
                        });
                    }}
                />
            </div>
            {error && (
                <div className="col-12">
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                </div>
            )}
        </div>
    );
}
